import { createBrowserHistory as createHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'

export const history = createHistory()
export const routeMiddleware = routerMiddleware(history)